import React from "react";
import PropTypes from "prop-types";
import FullPageLoader from "js/components/FullPageLoader";
import { withRouter } from "js/components/Root/withRouter";
import { LoginFailure } from "js/api/authApi";
import * as authApi from "js/api/authApi";
import { useUserSessionStore } from "stores/v2/userSessionStore";

type MyProps = {
	router: IComponentRouter;
};

class AutoMagicLogin extends React.Component<MyProps> {
	componentDidMount() {
		authApi
			.loginAutomatic(this.props.router.location.search)
			.then(async (res) => {
				if (res.token) {
					const successAuth = {
						token: res.token,
						username: res.username,
						deviceid: res.deviceid,
					};
					// eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore Ignore for now
					await useUserSessionStore.getState().handleAuthenticationSuccess(successAuth);
					this.props.router.navigate("/classrooms");
				} else {
					/* Its possible that the automatic login was disabled by the admin, but we still ended up with a deviceid */
					if (res.deviceid) {
						this.props.router.navigate("/login?deviceid=" + res.deviceid);
					} else {
						this.props.router.navigate("/login");
					}
				}
			})
			.catch((error) => useUserSessionStore.getState().handleAuthenticationFailure(error as LoginFailure));
	}

	render() {
		return <FullPageLoader message="Logging in" />;
	}

	static propTypes = {
		location: PropTypes.object,
		router: PropTypes.object.isRequired,
	};
}

export default withRouter(AutoMagicLogin);
